import React from 'react';
import { Button, Typography, Box } from '@mui/material';
import {FileUploadProps} from "../../types/types";


const FileUpload: React.FC<FileUploadProps> = ({
  onFileSelect,
  accept = '.jpg,.pdf'
}) => {
  const fileInputRef = React.useRef<HTMLInputElement>(null);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file && (file.type === 'application/pdf' || file.type === 'image/jpeg')) {
      onFileSelect(file);
    } else {
      alert('Only JPG or PDF files are allowed.');
    }
    // Clear input so selecting the same file again triggers onChange
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  return (
    <Box>
      <input
        type="file"
        accept={accept}
        onChange={handleFileChange}
        ref={fileInputRef}
        style={{ display: 'none' }}
      />
      <Button variant="contained" color='info' onClick={() => fileInputRef.current?.click()}>
        Upload File
      </Button>
    </Box>
  );
};

export default FileUpload;
